import { useEffect } from 'react'
import { useInfiniteQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getFinancialLoans } from 'services/financialHistory'
import posthog from 'posthog-js'

export default function useGetLoans() {
    const { poolship, moneyPool } = useParams()
    const { data, isLoading, fetchNextPage, refetch, remove } =
        useInfiniteQuery(
            ['money-pools-detail-users', moneyPool],
            ({ pageParam = 1, queryKey }) =>
                getFinancialLoans(pageParam, moneyPool, poolship),
            {
                getNextPageParam: (lastPage, allPages) => {
                    const lastRecord = allPages[allPages.length - 1]?.next || ''
                    return lastRecord
                        ? new URL(lastRecord).searchParams.get('page')
                        : undefined
                },
                onError: (error: any) => {
                    posthog.capture('member_loans_load_failed', {
                        fund_id: moneyPool,
                        poolship_id: poolship,
                        status: error?.response?.status,
                    })
                },
            }
        )
    useEffect(() => {
        remove()
        refetch()
    }, [moneyPool, poolship, remove, refetch])
    return {
        loans: data,
        isLoadingLoans: isLoading,
        fetchNextPage,
        refetchLoans: refetch,
    }
}
